import { JSONSchema7Definition } from 'json-schema';

declare module 'json-schema' {
    export interface JSONSchema7 {
        enumNames?: Array<string | number>;
    }
}

interface Schema {
    [key: string]: JSONSchema7Definition;
}

const schema: Schema = {
    widgetAltName: {
        type: 'string',
        title: 'Widget Name',
        default: '',
    },
    widgetDesc: {
        type: 'string',
        title: 'Widget Description',
        default: '',
    },
};

const group = {
    'Component Info': ['widgetAltName', 'widgetDesc'],
};

const uiSchema = {
    widgetAltName: { 'ui:widget': 'CustomTextInput' },
    widgetDesc: { 'ui:widget': 'CustomTextInput' },
};

export const ComponentInfoSchema = {
    schema,
    group,
    uiSchema,
};
